<template>
    <BaseSection
        class="section--full-width-image"
        width="bleed"
    >
        <PhotoCollage :images="content.images" />
    </BaseSection>
</template>

<script>
export default {
    props: {
        content: {
            type: Object,
            required: true,
            default: () => {
                return {};
            },
        },
    },
};
</script>
